/**
 * SSO Authentication & Federated Logout Service
 */

export function getSsoBaseUrl() {
  return process.env.REACT_APP_SSO_BASE_URL?.replace(/\/$/, "") || "http://localhost:8080";
}

export function getSsoPortalUrl() {
  return process.env.REACT_APP_SSO_PORTAL_URL?.replace(/\/$/, "") || "http://localhost:3000";
}

/**
 * Safely parse JWT payload.
 */
export function parseJwt(token) {
  if (!token || typeof token !== "string") return null;
  try {
    const base64Url = token.split(".")[1];
    if (!base64Url) return null;
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    return null;
  }
}

/**
 * Check if token is present and not expired.
 */
export function isTokenValid(token) {
  if (!token) return false;
  const payload = parseJwt(token);
  if (!payload || !payload.exp) {
    // If not a parseable JWT, check if marked authenticated
    return localStorage.getItem("isAuthenticated") === "true";
  }
  // exp is in seconds, Date.now() in ms
  const isExpired = Date.now() >= payload.exp * 1000;
  return !isExpired;
}

/**
 * Clear local session and redirect to SSO portal login.
 */
export function handleUnauthorized() {
  localStorage.clear();
  sessionStorage.clear();
  const ssoPortalUrl = getSsoPortalUrl();
  window.location.href = `${ssoPortalUrl}/login`;
}

export async function performFederatedLogout() {
  const token = localStorage.getItem("accessToken");
  const ssoBaseUrl = getSsoBaseUrl();
  const ssoPortalUrl = getSsoPortalUrl();
  const postLogoutRedirectUri = `${ssoPortalUrl}/login`;

  localStorage.clear();
  sessionStorage.clear();

  if (token) {
    try {
      const response = await fetch(`${ssoBaseUrl}/api/v1/auth/logout`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          federatedLogout: true,
          postLogoutRedirectUri: postLogoutRedirectUri,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        if (data && data.federated_logout_url) {
          window.location.href = data.federated_logout_url;
          return;
        }
      }
    } catch (e) {
      console.warn("SSO backend logout failed:", e);
    }
  }

  window.location.href = postLogoutRedirectUri;
}
